function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "layer1"
}, React.createElement("path", {
  id: "path2989",
  d: "m814.29 606.65a314.29 314.29 0 1 1 -628.57 0 314.29 314.29 0 1 1 628.57 0z",
  stroke: "#000",
  strokeWidth: 5,
  transform: "matrix(1.1048 0 0 1.1048 -179.21 -162.53)"
}), React.createElement("g", {
  id: "g3763",
  transform: "matrix(.91837 0 0 .91837 47.587 10.944)",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 133.87,
  fill: "none"
}, React.createElement("path", {
  id: "path2991",
  d: "m176.51 362.87 356.13 356.13"
}), React.createElement("path", {
  id: "path2993",
  d: "m532.64 362.87-356.13 356.13"
})));

var SvgCloseButton = function SvgCloseButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "svg2",
    viewBox: "0 0 744.09 1052.4",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-button.6bb56bee.svg";
export { ForwardRef as ReactComponent };